import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useIntl } from 'react-intl';
import { clearChatHistory } from '../api';
import styles from './clear-chat-dialog.module.css';

export const ClearChatDialog = ({ isOpen, onClose, onCleared, onError }) => {
	const intl = useIntl();
	const [isDeleting, setIsDeleting] = useState(false);

	if (!isOpen) return null;

	const handleConfirm = async () => {
		setIsDeleting(true);
		try {
			await clearChatHistory();
			onCleared();
			onClose();
		} catch (error) {
			console.error('Failed to clear history:', error);
			onError(intl.formatMessage({ id: 'AIAdvisorIDMessage7' }));
		} finally {
			setIsDeleting(false);
		}
	};

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.modal} onClick={e => e.stopPropagation()}>
				<AlertTriangle size={48} className={styles.warningIcon} />
				<h3 className={styles.title}>
					{intl.formatMessage({ id: 'AIAdvisorID7' })}
				</h3>
				<p className={styles.message}>
					{intl.formatMessage({ id: 'AIAdvisorID8' })}
				</p>
				<div className={styles.buttons}>
					<button
						className={styles.confirmButton}
						onClick={handleConfirm}
						disabled={isDeleting}
					>
						{intl.formatMessage({
							id: isDeleting ? 'AIAdvisorID9' : 'AIAdvisorID10',
						})}
					</button>
					<button
						className={styles.cancelButton}
						onClick={onClose}
						disabled={isDeleting}
					>
						{intl.formatMessage({ id: 'AIAdvisorID11' })}
					</button>
				</div>
			</div>
		</div>
	);
};
